module.exports = __webpack_public_path__ + "img/bg_about us.194df735.png";